export enum ColorStates {
    Info = 'info',
    Success = 'success',
    Warning = 'warning',
    Alert = 'alert',
}
